'use client';

import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type Query,
} from '@tanstack/react-query';
import {
  getScheduledLiveStreams,
  type ScheduledLiveStreamsResponse,
} from 'services/scheduledLiveStreams';

type ScheduledLiveStreamsOptions = Partial<
  Omit<UseQueryOptions<ScheduledLiveStreamsResponse>, 'queryKey' | 'queryFn'>
>;

const useGetScheduledLiveStreams = (
  options: ScheduledLiveStreamsOptions = {},
): UseQueryResult<ScheduledLiveStreamsResponse> =>
  useQuery<ScheduledLiveStreamsResponse>({
    queryKey: ['scheduledLiveStreams'],
    queryFn: getScheduledLiveStreams,
    refetchInterval: (query: Query<ScheduledLiveStreamsResponse>) => {
      const hasUpcoming = (query.state.data?.list?.length ?? 0) > 0;
      return hasUpcoming ? 120000 : 300000;
    },
    refetchOnWindowFocus: false,
    staleTime: 60000,
    ...options,
  });

export default useGetScheduledLiveStreams;
